var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10,10C9.083,10 8.333,9.25 8.333,8.333C8.333,7.417 9.083,6.667 10,6.667C10.917,6.667 11.667,7.417 11.667,8.333C11.667,9.25 10.917,10 10,10ZM15,8.5C15,5.475 12.792,3.333 10,3.333C7.208,3.333 5,5.475 5,8.5C5,10.45 6.625,13.033 10,16.117C13.375,13.033 15,10.45 15,8.5ZM10,1.667C13.5,1.667 16.667,4.35 16.667,8.5C16.667,11.267 14.442,14.542 10,18.333C5.558,14.542 3.333,11.267 3.333,8.5C3.333,4.35 6.5,1.667 10,1.667Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/Place.3dc48de58a5eb611830636a74815e81d.svg";
export { ForwardRef as ReactComponent };